var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"custom-class":"audit-logs-dialog-layout","title":_vm.$tf('audit_logs_details'),"top":"0","visible":"","modal":""},on:{"close":_vm.closeHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }